// Utility layer (TS-2.5.04) - pure, no side effects. The #RRGGBB shape check shared by
// ReferenceValueForm's colorHex field and BrandingPanel's per-token hex inputs (D-241's posture
// for both): a client-side HINT, not a gate. The server remains the authority on whether a value
// is accepted - callers never block typing or submitting on this, they only surface the format
// hint for the overwhelmingly common typo (missing "#", short hex, etc.).
export const COLOR_HEX_PATTERN = /^#[0-9a-fA-F]{6}$/;

export function isValidColorHex(value: string): boolean {
  return COLOR_HEX_PATTERN.test(value.trim());
}
